export interface AdminCountry {
  _id: string;
  country_code: string;
  name: string;
  currency_sign: string;
  currency_code: string;
  account_no: string;
  bank_code: string;
  wallet_no: string;
  numeric_code: string;
  iso_code_2: string;
  iso_code_3: string;
}
export interface AuthUserResponse {
  data: any;
  message: string;
  status: string;
}
export interface AuthUser {
  country_code: string;
  createdAt: string;
  disabled: boolean;
  email: string;
  firstName: string;
  is_active: boolean;
  iso_code_2: string;
  lastName: string;
  phoneNumber: string;
  roles: string[];
  schemeCode: string;
  super_user: boolean;
  updatedAt: string;
  userType: string;
  user_level: number;
  walletNo: string;
  __v: number;
  _id: string;
}

export interface LoginSucessResponseInterface {
  status: boolean;
  meta: any;
  data: {
    session_id: string;
    type: string;
    merchant_id: string;
    data: any;
    token: string;
  };
}

export interface CompanyProfile {
  addressLine1: string;
  addressLine2: string;
  companyName: string;
  companyNumber: string;
  companyStatus: string;
  dateOfCreation: string;
  hasBeenLiquidated: boolean;
  jurisdiction: string;
  locality: string;
  postalCode: string;
  region: string;
  sicCodes: string[];
  type: string;
  officers: {
    activeCount: number;
    resignedCount: number;
    inactiveCount: number;
    totalResults: number;
    officers: Officer[];
  };
}

interface Officer {
  name: string;
  appointedOn: string;
  occupation: string;
  officerRole: string;
  nationality: string;
  countryOfResidence: string;
  address: {
    country: string;
    postalCode: string;
    locality: string;
    addressLine1: string;
    addressLine2: string;
    premises: string;
  };
  dateOfBirth: {
    month: number;
    year: number;
  };
}

export interface transaction {}
export interface ICreatePastor {
  title?: string;
  churchId?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  address?: string;
  password?: string;
  phoneNumber?: string;
  gender?: string;
  country?: string;
  region?: string;
  city?: string;
  zipcode?: string;
  userType?: string;
}
export interface IBroadcast {
  title?: string;
  message?: string;
  messageFor?: string[];
  fileType?: string;
  fileUrl?: string;
  additionalLink?: string;
}

type NotificationCredentialDto = {
  email: string;
  phoneNumber: string;
};

export interface IAddContinent {
  name: string;
}

export interface IChurch {
  country: string;
  state: string;
  city: string;
  address: string;
  zipCode: string;
  name: string;
  churchId?: number;
  branch?: number;
  areaId?: number;
  districtId?: number;
  zoneId?: number;
  code?: string;
  lat?: string;
  long?: string;
  id?: any;
  pastorInCharge?: any;
  assistantPastor?: any;
  secretary?: any;
  mobileNumber?:any
  memberId?:any
  area?: string;
  district?: string; 
  zinCode?: string;
  pastorName?:any
  assistantPastorName?:any
  assistantPastorNumber?:any
  secretaryName?:any
  assistantPastorMemberId?:any
  secretaryMemberId?:any
  secretaryNumber?:any

}

export enum MESSAGE_FOR_TAGS {
  GLOBAL_ADMIN = "GLOBAL_ADMIN",
  CONTINENTAL_ADMIN = "CONTINENTAL_ADMIN",
  COUNTRY_ADMIN = "COUNTRY_ADMIN",
  CHURCH_ADMIN = "CHURCH_ADMIN",
  AREA_ADMIN = "AREA_ADMIN",
  DISTRICT_ADMIN = "DISTRICT_ADMIN",
  ZONAL_ADMIN = "ZONAL_ADMIN",
  NEW_CONVERT = "NEW_CONVERT",
  FIRST_TIMER = "FIRST_TIMER",
  PASTOR = "PASTOR",
  USER = "USER",
}
export enum PASTOR_OPTIONS {
  MR = "Mr.",
  MRS = "Mrs.",
  MISS = "Miss",
  MS = "Ms",
  SIR = "Sir",
  MADAM = "Madam",
  DR = "Dr.",
  PASTOR = "Pastor",
  REV = "Rev.",
}
export enum CONTINENT_OPTIONS {
  North_America = " North America",
  South_America = "South America",
  Asia = "Asia",
  Europe = "Europe",
  Oceania = "Oceania",
  Africa = "Africa",
  Antarctic = "Antarctic",
}
export enum SESSION_USERTYPE {
  USER = "USER",
  GLOBAL_ADMIN = "GLOBAL_ADMIN",
  CONTINENTAL_ADMIN = "CONTINENTAL_ADMIN",
  COUNTRY_ADMIN = "COUNTRY_ADMIN",
  CHURCH_ADMIN = "CHURCH_ADMIN",
  AREA_ADMIN = "AREA_ADMIN",
  DISTRICT_ADMIN = "DISTRICT_ADMIN",
  ZONAL_ADMIN = "ZONAL_ADMIN",
}

export enum SESSION_ROLE {
  GLOBAL_Pastor = "Global Pastor",
  National_Pastor = "National Pastor",
  Resident_Pastor = "Resident Pastor",
  Area_Pastor = "Area Pastor",
  Mission_Pastor ="Mission Pastor",
  Zonal_Pastor = "Zonal Pastor",
  Cell_Minister = "Cell Minister",
  HFC_Pastor= "HFC Pastor",
  District_Pastor= "District Pastor",
  Province_Pastor= "Province Pastor", // just as Area pastor role
  Pastor = "Pastor",
  Associate_Pastor = 'Associate Pastor', // just as Resident pastor role
  Assistant_Pastor = 'Assistant Pastor',  // just as Resident pastor role
  WSF_Coordinator = 'WSF Coordinator',
}
export enum ASSIGN_PASTOR_ENUM {
  National_Pastor = "branch-pastor",
  Resident_Pastor = "area-pastor",
  Area_Pastor = "zonal-pastor",
  Zonal_Pastor = "cell-minister",
}

export enum Role {
  PASTOR = "Pastor",
  RESIDENCE_PASTOR = "Residence_Pastor",
  DEACON = "Deacon",
  DEACONESS = "Deaconess",
  EVANGELIST = "Evangelist",
  USHER = "Usher",
  APOSTLE = "Apostle",
}
